import axios from '@/libs/api.request'
// import config from '@/config'

// emc 基础URL
const emcUrl = 'http://127.0.0.1:9000/resource/'

// 查询getDiskList列表
export const getDiskList = (params) => {
  return axios.request({
    url: emcUrl + 'disk_query',
    params: params,
    method: 'get'
  })
}

// 查询getLunList列表
export const getLunList = (params) => {
  return axios.request({
    url: emcUrl + 'lun_query',
    params: params,
    method: 'get'
  })
}
